<template>
  <div class="page">
    <div class="container">
      <element-processor @submit="submit" :data="processorData" @submitOtherEst="submitOtherEst">

        <element-processor-step :data="processorData.steps[0]">
          <ul class="form-item-list">
            <li><h3>차량 기본정보</h3></li>
            <li><element-spread-select v-model="processorData.steps[0].formData.usage.value" :error="processorData.steps[0].formData.usage.error" :label="processorData.steps[0].formData.usage.label" :items="processorData.steps[0].formData.usage.items" /></li>
            <li><element-spread-select v-model="processorData.steps[0].formData.career.value" :error="processorData.steps[0].formData.career.error" :label="processorData.steps[0].formData.career.label" :items="processorData.steps[0].formData.career.items" /></li>
            <li><element-car-radio v-model="processorData.steps[0].formData.information.value" :error="processorData.steps[0].formData.information.error" :label="processorData.steps[0].formData.information.label" :items="processorData.steps[0].formData.information.items" /></li>

            <li><element-textbox v-if="processorData.steps[0].formData.information.value == '차량번호를 알고 있습니다.'" v-model="processorData.steps[0].formData.carNumber.value" :error="processorData.steps[0].formData.carNumber.error" :label="processorData.steps[0].formData.carNumber.label" :placeholder="processorData.steps[0].formData.carNumber.placeholder"/></li>
            <li><element-textbox v-if="processorData.steps[0].formData.information.value == '차대번호를 알고 있습니다.'" v-model="processorData.steps[0].formData.vinNumber.value" :error="processorData.steps[0].formData.vinNumber.error" :label="processorData.steps[0].formData.vinNumber.label" :placeholder="processorData.steps[0].formData.vinNumber.placeholder"/></li>

            <li><element-calendar v-model="processorData.steps[0].formData.startDate.value" :error="processorData.steps[0].formData.startDate.error" :label="processorData.steps[0].formData.startDate.label" :items="processorData.steps[0].formData.startDate.items" :isWeekend="true"/></li>
            <li><element-spread-select v-model="processorData.steps[0].formData.carType.value" :error="processorData.steps[0].formData.carType.error" :label="processorData.steps[0].formData.carType.label" :items="processorData.steps[0].formData.carType.items" /></li>
            <div class="form-item-caution" v-for="item in processorData.steps[0].formData.carType.items" v-if="item.value == processorData.steps[0].formData.carType.value">{{ item.description }}</div>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[1]">
          <ul class="form-item-list">
            <li><h3>차량 세부 정보</h3></li>
            <li style="padding-top: 5rem;">
              <element-tab class="over">
                <element-tab-item @click="optionTab = '선택'" :on="optionTab == '선택'">선택</element-tab-item>
                <element-tab-item @click="optionTab = '검색'" :on="optionTab == '검색'">검색</element-tab-item>
              </element-tab>
              <div class="option-tab-service" v-if="optionTab == '선택'">
                <element-car-content-checkbox @checkAuto="checkAuto"
                @statusSearchOptions="searchPopup"
                :error="processorData.steps[1].formData.detailInformation.error"
                :label="processorData.steps[1].formData.detailInformation.label"
                :items="processorData.steps[1].formData.detailInformation.items"
                :statusPopup="statusPopup" :index="0" />
                <element-spread-select
                v-model="processorData.steps[1].formData.AdditionalOptions.value"
                :error="processorData.steps[1].formData.AdditionalOptions.error"
                :label="processorData.steps[1].formData.AdditionalOptions.label"
                :items="processorData.steps[1].formData.AdditionalOptions.items" />
                <div class="form-item-caution" v-if="processorData.steps[1].formData.AdditionalOptions.value == '있음'">{{ processorData.steps[1].formData.AdditionalOptions.description }}</div>

                <element-car-parts-list
                v-if="processorData.steps[1].formData.AdditionalOptions.value == '있음'"
                v-model="processorData.steps[1].formData.OptionList.value"
                :error="processorData.steps[1].formData.OptionList.error"
                :label="processorData.steps[1].formData.OptionList.label"
                :list="processorData.steps[1].formData.OptionList.list"
                :items="processorData.steps[1].formData.OptionList.parts"
                :partsdate="processorData.steps[1].formData.detailInformation.value.year"
                :partedate="processorData.steps[0].formData.startDate.value"
                />
              </div>
              <div class="option-tab-service" v-if="optionTab == '검색'">
                <element-search @searchComplete="setSearchResult"
                  :type="processorData.steps[0].formData.carType.value"
                  :insur_startdate="processorData.steps[0].formData.startDate.value"
                  :placeholder="'아반떼, 2019, MD 등으로 자유롭게 입력'" />
                <div class="form-item-caution">차명과 모델명은 띄어주세요.<br/>(예: 그랜져 IG, BMW 520, 벤츠 E200)</div>
              </div>
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[2]">
          <ul class="form-item-list">
            <li><h3>운전자정보</h3></li>
            <li>
                <element-spread-select
                v-model="processorData.steps[2].formData.range.value"
                :usage="processorData.steps[0].formData.usage.value"
                :carType="processorData.steps[0].formData.carType.value"

                :error="processorData.steps[2].formData.range.error"
                :label="processorData.steps[2].formData.range.label"
                :items="processorData.steps[2].formData.range.items"
                :cautiontextView="true">
                  <element-spread-select style="margin-top:1rem;"

                    :usage="processorData.steps[0].formData.usage.value"
                    :carType="processorData.steps[0].formData.carType.value"
                    v-model="processorData.steps[2].formData.range2.value"
                    :error="processorData.steps[2].formData.range2.error"
                    :label="processorData.steps[2].formData.range2.label"
                    :items="processorData.steps[2].formData.range2.items"
                    />
                </element-spread-select>
              </li>
            <!-- <li v-if="processorData.steps[0].formData.carType.value == '승용차'"><element-textbox v-model="processorData.steps[2].formData.birth.value" :error="processorData.steps[2].formData.birth.error" :label="processorData.steps[2].formData.birth.label" :placeholder="processorData.steps[2].formData.birth.placeholder" /></li> -->
            <!-- <li v-if="processorData.steps[0].formData.carType.value == '승용차'"><div class="form-item-caution">운전자 중에서 최저 연령자의 만 연령을 입력하세요. 운전자 범위에 속하더라도 최저 연령자보다 어린 사람이 운전하면 사고 보상을 받을 수 없습니다.</div></li> -->
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[3]">
          <ul class="form-item-list">
            <li><h3>보장항목</h3></li>
            <li v-for="(options, index) in processorData.steps[3].formData.insureOptions">
              <element-content-checkbox @status="popup"
              :usage="processorData.steps[0].formData.usage.value == '법인' && processorData.steps[0].formData.carType.value != '승용차'"
              v-model="processorData.steps[3].formData.insureOptions[index].value"
              :error="processorData.steps[3].formData.insureOptions[index].error"
              :label="processorData.steps[3].formData.insureOptions[index].label"
              :items="processorData.steps[3].formData.insureOptions[index].items"
              :index="index"
              :requirement="processorData.steps[3].formData.insureOptions[index].requirement"/>
            </li>
          </ul>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[4]">
          <include-car-estimate-auth :data="processorData.steps[0]" @updateprocessorData="updateprocessorData" :isCarInsure="true"/>
        </element-processor-step>

        <!-- <element-processor-step :data="processorData.steps[5]">
          <ul class="form-item-list">
            <li><h3>자필서명</h3></li>
            <li><element-signature @saveSign="saveSign" /></li>
          </ul>
        </element-processor-step> -->

        <element-processor-step :data="processorData.steps[5]">
          <ul class="form-item-list consult">
            <li><div class="form-item-caution">상담예약을 하시면 인수가능한 정확한 보험료와 5대 보증 6대 사은 서비스 안내 받고 <b style="color:#174be6; font-weight: bold;"> 매년 편리하게 유리한 보험사로 가입</b>하실 수 있습니다.</div></li>
            <li class="is-multiple">
              <element-calendar v-model="processorData.steps[5].formData.consultDate.value" :error="processorData.steps[5].formData.consultDate.error" :label="processorData.steps[5].formData.consultDate.label" :placeholder="processorData.steps[5].formData.consultDate.placeholder" />
              <element-time-select v-model="processorData.steps[5].formData.consultTime.value" :date="processorData.steps[5].formData.consultDate.value" :error="processorData.steps[5].formData.consultTime.error" :label="processorData.steps[5].formData.consultTime.label" :placeholder="processorData.steps[5].formData.consultTime.placeholder" />
            </li>
            <li><element-textarea v-model="processorData.steps[5].formData.consultRemark.value" :error="processorData.steps[5].formData.consultRemark.error" :label="processorData.steps[5].formData.consultRemark.label" :placeholder="processorData.steps[5].formData.consultRemark.placeholder" /></li>
            <li><div class="form-item-caution">입력하신 내용을 바탕으로 상담원이 상담 전 확인 및 관련 내용을 준비하여 상담을 진행합니다.</div></li>
          </ul>
        </element-processor-step>
        <element-processor-step :data="processorData.steps[6]">
          <template v-if="!$route.query.event">
              <include-estimate-complete :data="processorData.steps[6]" />
          </template>
          <template v-else>
            <include-estimate-complete-with-event :data="processorData.steps[6]" :estimate_id="createdEstimateId"/>
          </template>
        </element-processor-step>

        <element-processor-step :data="processorData.steps[7]">
          <include-other-estimate :data="processorData.steps[7]" :type="processorData.title"/>
        </element-processor-step>

        <element-search-popup :auto="autoName"
          @searchComplete="searchComplete"
          @statusSearchOptions="searchPopup"
          @checkPopup="searchValue"

          :label="processorData.steps[1].formData.detailInformation.items[statusSearchOptions.index].label"
          :subLabel="processorData.steps[1].formData.detailInformation.items[statusSearchOptions.index].subLabel"

          v-if="statusSearchOptions.popup" :statusPopup="statusSearchOptions"
          :data="processorData.steps[1].formData.detailInformation"
          :description="''"
          :type="processorData.steps[0].formData.carType.value"
          :insur_startdate="processorData.steps[0].formData.startDate.value">
        </element-search-popup>

        <transition name="popup">
          <element-popup v-if="statusPopup.popup"
          @status="popup"
          @checkPopup="checkValue"
          v-model="processorData.steps[3].formData.insureOptions[statusPopup.option].value"
          :process_title="processorData.title"
          :label="processorData.steps[3].formData.insureOptions[statusPopup.option].items[statusPopup.index].label"
          :subLabel="processorData.steps[3].formData.insureOptions[statusPopup.option].items[statusPopup.index].subLabel"
          :statusPopup="statusPopup"
          :data="processorData.steps[3].formData.insureOptions[statusPopup.option]"
          :subDescription="!!processorData.steps[3].formData.insureOptions[statusPopup.option].items[statusPopup.index].subDescription ? processorData.steps[3].formData.insureOptions[statusPopup.option].items[statusPopup.index].subDescription : false"
          :description="processorData.steps[3].formData.insureOptions[statusPopup.option].items[statusPopup.index].description">
          </element-popup>
        </transition>
      </element-processor>
    </div>
  </div>
</template>

<script>

import moment from 'moment'


export default {
  data(){
    return {
      moment: moment,
      statusSearchOptions: {
        popup: false,
        index: '',
        option: -1,
      },
      statusPopup: {
        popup: false,
        index: '',
        option: -1,
      },
      statusTab: {
        popup: false,
        index: '',
        option: -1,
      },
      autoName: '',
      optionTab: '선택',
      processorData: {
        title: "자동차보험 견적서",
        cureData: false,
        steps: [
          {
            title: "차량 기본정보",
            formData: {
              usage: {
                label: "차량용도",
                value: "",
                error: "",
                items: [
                  { value: "개인", label: "개인" },
                  { value: "법인", label: "법인" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              career: {
                label: "가입경력",
                value: "",
                error: "",
                items: [
                  { value: "있음", label: "있음" },
                  { value: "없음", label: "없음" }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              information: {
                label: "차량 기본정보",
                value: "",
                error: "",
                items: [
                  { value: "차량번호를 알고 있습니다.", label: "차량번호를 알고 있습니다.", description: "구입하는 차량에 이미 차량번호가 이미 있는경우" },
                  { value: "차대번호를 알고 있습니다.", label: "차대번호를 알고 있습니다.", description: "구입하거나 양도받을 자동차를 아직 정하지 않은 경우를 말합니다." },
                  { value: "자동차를 구입할 예정입니다.", label: "자동차를 구입할 예정입니다.", description: "구입하거나 양도받을 자동차를 아직 정하지 않은 경우를 말합니다." }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              carNumber: {
                label: "차량번호",
                value: "",
                error: "",
                placeholder: "차량번호 입력(예: 123가 3456 또는 12가 3456)",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
                use: false,
              },
              vinNumber: {
                label: "차대번호",
                value: "",
                error: "",
                placeholder: "차대번호 입력(예: KMHEL13CPYA000001)",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
                use: false,
              },
              startDate: {
                label: "보험시작일",
                value: new Date(),
                error: "",
              },
              carType: {
                label: "차량종류",
                value: "",
                error: "",
                items: [
                  { value: "승용차", label: "승용차", description: "승용차는 승차 정원이 10인 이하인 차량입니다." },
                  { value: "승합차", label: "승합차", description: "승합차는 승차 정원이 11인 이상인 차량입니다." },
                  { value: "화물차", label: "화물차", description: "화물차는 적재함이 있는 차량입니다." }
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
            }
          },
          {
            title: "차량 세부정보",
            formData: {
              detailInformation: {
                label: "차량모델",
                value: "",
                error: "",
                code: '',
                items: [
                  { value: "", label: "제조사", subLabel: "", default: "제조사 선택",
                    options: [
                      { value: "현대", label: "현대" },
                      { value: "기아", label: "기아" },
                      { value: "르노삼성", label: "르노삼성" },
                      { value: "쌍용", label: "쌍용" },
                      { value: "쉐보레/GM대우", label: "쉐보레/GM대우" },
                      { value: "외제차", label: "외제차" }
                    ] }
                  ,
                  { value: "", label: "차명", subLabel: "", default: "차명 선택",
                    options: [] },
                  { value: "", label: "등록연도", subLabel: "", default: "등록연도 선택",
                    options: [] },
                  { value: "", label: "세부차명", subLabel: "세부차명 선택", default: "세부차명 선택",
                    options: [] },
                  { value: "", label: "세부옵션", subLabel: "세부옵션 선택", default: "세부옵션 선택",
                    options: [] },
                  ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              AdditionalOptions: {
                label: "추가장착품",
                value: "없음",
                error: "",
                description: "차량 출고 시에는 장착되지 않았으나, 출고 후 정비업체에서 별도 추가한 장착품이 있다면 선택하세요. 귀하의 추가장착품이 목록에 없는 경우에는 기타를 선택한 후에 장착품명, 장착연월, 장착가액 등을 입력하세요.",
                items: [
                  { value: "있음", label: "있음" },
                  { value: "없음", label: "없음" }
                ]
              },
              OptionList: {
                label: "장착품",
                value: [],
                error: "",
                list: [],
                parts: [
                  { value: "네비게이션", label: "네비게이션" },
                  { value: "블랙박스(할인특약)", label: "블랙박스(할인특약)" },
                  { value: "선루프", label: "선루프" },
                  { value: "차선이탈경고장치(할인특약)", label: "차선이탈경고장치(할인특약)" },
                  { value: "전방충돌경고장치(할인특약)", label: "전방충돌경고장치(할인특약)" },
                  { value: "기타", label: "기타" }
                ],
                use: false
              }
            }
          },
          {
            title: "운전자정보",
            formData: {
              range: {
                label: "운전자 범위",
                value: "",
                error: "",
                items: [
                  { value: "기명1인한정", label: "본인(자동차 소유자)", userCategory: "개인", carCategory: "", description: "차주 본인만 보상합니다." },
                  { value: "부부한정", label: "부부", userCategory: "개인", carCategory: "", description: "차주 본인과 배우자를 보상합니다." },
                  { value: "1인+1인(가족외) ", label: "본인 + 타인(지정1명)", userCategory: "개인", carCategory: "", description: "차주 본인과 지정하는 1인을 보상합니다." },
                  { value: "가특+형제", label: "가족 + 형제자매", userCategory: "개인", carCategory: "", description: "차주의 가족(배우자, 자녀, 본인 부모, 배우자 부모)과 차주의 형제자매를 보상합니다." },
                  { value: "가족한정", label: "가족(형제자매 제외)", userCategory: "개인", carCategory: "", description: "차주의 가족(배우자, 자녀, 본인 부모, 배우자 부모)을 보상합니다." },
                  { value: "누구나", label: "누구나 운전", userCategory: "개인", carCategory: "", description: "보험 가입 차량을 운전하는 누구나 보상합니다. " },

                  { value: "임직원", label: "임직원", userCategory: "법인", carCategory: "승용차", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "누구나 운전", label: "누구나 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              range2: {
                label: "운전자 연령",
                value: "",
                error: "",
                items: [
                  { value: "만 21세 이상 운전", label: "만 21세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 24세 이상 운전", label: "만 24세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 26세 이상 운전", label: "만 26세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 30세 이상 운전", label: "만 30세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 35세 이상 운전", label: "만 35세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "만 43세 이상 운전", label: "만 43세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "만 48세 이상 운전", label: "만 48세 이상 운전", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "전 연령", label: "전 연령", userCategory: "법인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},

                  { value: "만 21세 이상 운전", label: "만 21세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 24세 이상 운전", label: "만 24세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 26세 이상 운전", label: "만 26세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 30세 이상 운전", label: "만 30세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요" },
                  { value: "만 35세 이상 운전", label: "만 35세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "만 43세 이상 운전", label: "만 43세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "만 48세 이상 운전", label: "만 48세 이상 운전", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                  { value: "전 연령", label: "전 연령", userCategory: "개인", carCategory: "", description: "운전자를 선택하세요. 선택하지 않은 운전자가 낸 사고는 보상받지 못하므로 드물게 운전하는 사람 (예: 군복무, 유학, 별거 중인 가족 등)이라도 선택하세요"},
                ],
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ],
                use: false,
              },
              // birth: {
              //   label: "최저 연령 생년월일",
              //   value: "",
              //   error: "",
              //   placeholder: "생년월일 6자리 입력",
              //   validations: [
              //     // { type: "required", message: "필수항목입니다" },
              //     { type: "birth", message: "예) 950101" }
              //   ],
              //   use: false,
              // },
            }
          },
          {
            title: "보장항목",
            formData:
            {
              insureOptions: [
                {
                  label: "보장내용",
                  requirement: true,
                  value: [
                    { label: "대인배상 I", value: "타인 사상 시 1억 5천만원 이내 보상" },
                    { label: "대인배상 II", value: "무한보상" },
                    { label: "대물배상", value: "1억원" },
                    { label: "자기신체사고", value: { value: "3,000만원(부상 1,500만원)", label: "자기신체손해"} },
                    { label: "무보험차상해", value: "2억원" },
                    { label: "자기차량손해", value: "미가입" },
                    { label: "물적사고할증", value: "200만원" },
                    { label: "긴급출동", value: "가입" },
                  ],
                  error: "",
                  items: [
                    { value: "대인배상 I", label: "대인배상 I", description: [
                      { value: "타인 사망 시 최고 1억5천만원, 타인 상해 시 최고 3천만원 한도에서 보상합니다. 법에 따른 의무보험으로 속칭 '책임보험'이라고 하며 미가입시 최고 90만원의 과태료, 1년 이하의 징역 또는 500만원 이하의 벌금형을 부과받습니다." },
                      ], subLabel: "타인 사상 시 1억 5천만원 이내 보상", useage: true, link: { name: "Home" },
                      options: [
                        { value: "타인 사상 시 1억 5천만원 이내 보상", label: "타인 사상 시 1억 5천만원 이내 보상" },
                      ]
                    },
                    { value: "대인배상 II", label: "대인배상 II", description: [
                      { value: "타인을 죽게 하거나 다치게 할 경우 대인배상 I 에서 보상하는 금액을 초과하는 손해를 보상합니다. 무한보상으로 가입하면 교통사고처리특례법에 따라 운전자가 형사처벌 면제 특례를 받으므로, 미가입 외에는 모두 '무한보상'을 선택합니다." }
                      ], subLabel: "무한보상", useage: true, link: { name: "Home" },
                      options: [
                        { value: "무한보상", label: "무한보상" },
                        { value: "미가입", label: "미가입" },
                      ]
                    },
                    { value: "대물배상", label: "대물배상", description: [
                      { value: "타인의 재물이나 차량에 손실을 입힐 경우 가입금액 한도 내에서 보상합니다. 의무보험으로 운전자가 형사처벌 면제 특례를 받으려면 2천만원 이상 가입해야 합니다." },
                      ], subLabel: "1억원", useage: true, link: { name: "Home" },
                      options: [
                        { value: "10억원", label: "10억원" },
                        { value: "5억원", label: "5억원" },
                        { value: "3억원", label: "3억원" },
                        { value: "2억원", label: "2억원" },
                        { value: "1억원", label: "1억원" },
                        { value: "5천만원", label: "5천만원" },
                        { value: "3천만원", label: "3천만원" },
                        { value: "2천만원", label: "2천만원" },
                      ]
                    },
                    { value: "자기신체사고", label: "자기신체사고",
                      description: [
                        { value: "부상 및 후유장해시 가입한도액 내에서 상해(장해)급수별 지급금액 한도로 보상합니다. 보험에 가입한 자동차의 사고로 피보험자 본인 또는 그 가족(부모, 배우자 및 자녀)등이 다치거나 사망한 경우에 해당합니다." },
                      ],
                      subDescription: [
                        { value: "부상 및 후유장해시 가입한도액 내에서 치료비가 보상되며, 이외에도 장례비, 위자료, 상실수익액, 휴업손해 등을 포괄적으로 보상합니다. 보험에 가입한 자동차의 사고로 피보험자 본인 또는 그 가족(부모, 배우자 및 자녀)등이 자치거나 사망한 경우에 해당합니다." }
                      ],
                      subLabel: "[자기신체손해] 3,000만원(부상 1,500만원)",
                      useage: true,
                      link: { name: "Home" },
                      options: [
                        { value: "1억원(부상 5,000만원)", label: "1억원(부상 5,000만원)" },
                        { value: "1억원(부상 3,000만원)", label: "1억원(부상 3,000만원)" },
                        { value: "5,000만원(부상 5,000만원)", label: "5,000만원(부상 5,000만원)" },
                        { value: "5,000만원(부상 3,000만원)", label: "5,000만원(부상 3,000만원)" },
                        { value: "3,000만원(부상 3,000만원)", label: "3,000만원(부상 3,000만원)" },
                        { value: "3,000만원(부상 1,500만원)", label: "3,000만원(부상 1,500만원)" },
                        { value: "1,500만원(부상 1,500만원)", label: "1,500만원(부상 1,500만원)" },
                        { value: "미가입", label: "미가입" }
                      ],
                      subOptions: [
                        { value: "5억원(부상 5,000만원)", label: "5억원(부상 5,000만원)" },
                        { value: "2억원(부상 5,000만원)", label: "2억원(부상 5,000만원)" },
                        { value: "2억원(부상 2,000만원)", label: "2억원(부상 2,000만원)" },
                        { value: "1억원(부상 1억원)", label: "1억원(부상 1억원)" },
                        { value: "1억원(부상 3,000만원)", label: "1억원(부상 3,000만원)" },
                        { value: "1억원(부상 1,000만원)", label: "1억원(부상 1,000만원)" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "무보험차상해", label: "무보험차상해", description: [
                      { value: "차주 및 운전자, 그들의 가족이 무보험차 또는 뺑소니차에 상해를 입을 경우 가입금액 한도 내에서 보상 받습니다. 이 담보에 가입하면 '다른자동차운전담보특약'에 무료 가입되므로 다른 사람 차를 일시 운전하다 사고 발생 시 보상받을 수 있습니다." },
                      ], subLabel: "2억원", useage: true, link: { name: "Home" },
                      options: [
                        { value: "5억원", label: "5억원" },
                        { value: "2억원", label: "2억원" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "자기차량손해", label: "자기차량손해", description: [
                        { value: "자동차보험 가입 차량에 도난, 파손, 화재 등 발생 시 원상복구 금액을 가입금액 한도 내에서 보상합니다. 가입금액은 보험개발원에서 분기별로 발표하는 차량가액의 60%~100% 이내에서 결정할 수 있습니다." },
                      ], subLabel: "미가입", useage: true, link: { name: "Home" },
                      options: [
                        { value: "3,000만원(차량가액의 100%)", label: "3,000만원(차량가액의 100%)" },
                        { value: "2,000만원(차량가액의 60%)", label: "2,000만원(차량가액의 60%)" },
                        { value: "미가입", label: "미가입" }
                      ] },
                    { value: "물적사고할증", label: "물적사고할증", description: [
                      { value: "자동차보험 가입 차량에 도난, 파손, 화재 등 발생 시 원상복구 금액을 가입금액 한도 내에서 보상합니다. 가입금액은 보험개발원에서 분기별로 발표하는 차량가액의 60%~100% 이내에서 결정할 수 있습니다." },
                      ], subLabel: "200만원", useage: true, link: { name: "Home" },
                      options: [
                        { value: "200만원", label: "200만원" },
                        { value: "150만원", label: "150만원" },
                        { value: "100만원", label: "100만원" },
                        { value: "50만원", label: "50만원" },
                      ] },
                    { value: "긴급출동", label: "긴급출동", description: [
                      { value: "사고 및 고장으로 인한 차량 운행 불능 시 연간 5회까지 긴급출동 서비스를 무료로 받을 수 있습니다. (참고: 이 특약에 가입하지 않아도 보험사에 긴급출동 서비스를 신청할 수 있으나 출동 비용은 보험가입자가 긴급출동 업체에게 직접 내야 함)" }
                    ], subLabel: "가입", useage: true, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" }
                      ] },
                  ],
                },
                {
                  label: "할인특약",
                  value: [],
                  requirement: false,
                  error: "",
                  items: [
                    { value: "블랙박스 할인(1~6%)", label: "블랙박스 할인(1~6%)", description: [
                      { value: "블랙박스(영상기록장치)를 상시, 고정 장착한 경우 보험료를 할인하여 드립니다. " },
                      { value: " *블랙박스 가격은 차량가액에 포함되어 자기차량손해담보 보험료 신정시 반영됩니다." }
                    ], subLabel: "미가입", useage: true, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "마일리지 할인(2~34%)", label: "마일리지 할인(2~34%)", description: [
                      { value: "보험가입시 약정한 연간(역환산) 예상 주행거리를 준수할 경우 납입하신 보험료의 일정액을 환급하여 드립니다." }
                    ], subLabel: "미가입", useage: true, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "자녀 할인(3~15%)", label: "자녀 할인(3~15%)", description: [
                      { value: "가입자(피보험자)의 자녀가 특정연령 이하인 경우 보험료를 할인하여 드립니다." },
                      { value: "*태아~만 9세 이하 / 회사별 가입조건 및 할인율 상이" }
                    ], subLabel: "미가입", useage: false, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "커넥티드카 할인(7%)", label: "커넥티드카 할인(7%)", description: [
                      { value: "사고통보장치가 장착되어 아래의 서비스를 이용하는 고객에 대하여 보험료를 할인하여 드립니다." },
                      { value: "*현대자동차 - 블루링크 / 기아자동차 - UVO / 벤츠 - Emerency call " },
                      { value: " BMW - 커넥티드드라이브 / 랜드로버 - InControl / MINI - 커넥티드드라이브" }
                    ], subLabel: "미가입", useage: true, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "대중교통 할인(5~8%)", label: "대중교통 할인(5~8%)", description: [
                      { value: "직전 3개월간 대중교통이용액의 합산금액이 일정 조건 충족시 약정한 금액을 할인하여 드립니다.(1인한정 및 부부한정 가입자에 한함)" },
                      { value: "*대중교통범위 : 지하철, 버스(시내, 광역, 마을, 농어촌)" }
                    ], subLabel: "미가입", useage: false, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "T-map 할인(5~10%)", label: "T-map 할인(5~10%)", description: [
                      { value: "T-map을 이용한 운전점수가 일정수준(61점) 이상일 경우 보험료를 할인하여드립니다.(1인한정 및 부부한정 가입자에 한함.)" },
                      { value: "*T-map 이용 고객만 가입이 가능" }
                    ], subLabel: "미가입", useage: false, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                    { value: "서민우대 할인(8%)", label: "서민우대 할인(8%)", description: [
                      { value: "기초생활 수급자, 저소득자, 장애인, 고령자인 경우 일정조건충족시 보험료를 할인하여 드립니다." }
                    ], subLabel: "미가입", useage: false, link: { name: "Home" },
                      options: [
                        { value: "가입", label: "가입" },
                        { value: "미가입", label: "미가입" },
                      ] },
                  ]
                }
              ]
            }
          },
          {
            title: "본인 확인",
            formData: {
              // haslogin: {
              //   label: "회원번호",
              //   value: "",
              //   validations: [
              //     { type: "required", message: "-" }
              //   ]
              // },
              phone: {
                label: "휴대폰 번호",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              name: {
                label: "이름",
                value: "",
                validations: [
                  { type: "required", message: "-" }
                ]
              },
              email: {
                label: "이메일",
                value: "",
              },
              birth: {
                label: "생년월일",
                value: "",
                validations: [
                  { type: "required", message: "-" },
                ]
              },
            }
          },
          // {
          //   title: "자필서명",
          //   label: "",
          //   formData: {
          //     /*writeName: {
          //       label: "자필패드",
          //       value: "",
          //       error: "",
          //       validations: [
          //         { type: "required", message: "필수항목입니다" }
          //       ]
          //     },*/
          //     writeSign: {
          //       label: "서명패드",
          //       value: "",
          //       error: "",
          //       validations: [
          //         { type: "required", message: "필수항목입니다" }
          //       ]
          //     }
          //   }
          // },
          {
            title: "상담 예약",
            formData: {
              consultDate: {
                label: "상담 예약 일시",
                value: new Date(),
                error: "",
                placeholder: "날짜 선택"
              },
              consultTime: {
                label: "상담 예약 일시",
                value: "",
                error: "",
                placeholder: "시간",
                validations: [
                  { type: "required", message: "필수항목입니다" }
                ]
              },
              consultRemark: {
                label: "상담 전 남기실 말씀",
                value: "",
                error: "",
                placeholder: "특별히 보장 받고 싶은 보장 항목, 기간, 금액 또는 현재 가입 중인 보험 그리고 상담 전 남기실 말씀을 입력하십시오. (200자 이내)"
              },
            }
          },
          {
            title: "비교견적 신청이 완료되었습니다.",
            label: "입력하신 정보를 바탕으로 쉽게 추가 견적서를 신청하시겠습니까?"
          },
          {
            title: "다른 보험 표준 견적서 받아보기",
            label: "",
            value: []
          }
        ] // steps
      },
      createdEstimateId: null,
      reservation_inflow_referer_source: '',
    }
  },
  watch: {
    'processorData.steps.0.formData.information.value' : function (n) {
      // 'basicInformationCheck'
      if(n == '차량번호를 알고 있습니다.'){
        this.processorData.steps[0].formData.vinNumber.use = false;
        this.processorData.steps[0].formData.carNumber.use = true;
      }
      else if(n == '차대번호를 알고 있습니다.'){
        this.processorData.steps[0].formData.vinNumber.use = true;
        this.processorData.steps[0].formData.carNumber.use = false;
      }
      else{
        this.processorData.steps[0].formData.vinNumber.use = false;
        this.processorData.steps[0].formData.carNumber.use = false;
      }
    },
    'processorData.steps.1.formData.detailInformation.value' : 'checkPath',
    /*'processorData.steps.0.formData.carType.value': function (n) {
      if(n === "승용차"){
        this.processorData.steps[2].formData.birth.use = true;
      }else{
        this.processorData.steps[2].formData.birth.use = false;
      }
    },*/
    'processorData.steps.0.formData.usage.value': function (n) {
      if(n === "법인"){
        this.processorData.steps[2].formData.range2.use = true;
      }else{
        this.processorData.steps[2].formData.range2.use = true;
      }
    },
    'processorData.steps.1.formData.AdditionalOptions.value': function (n) {
      if(n === "있음"){
        this.processorData.steps[1].formData.OptionList.use = true;
      }else{
        this.processorData.steps[1].formData.OptionList.use = false;
      }
    },

  },
  created() {
    const { date, time } = this.$getDefaultConsultTime();

    if (date !== '') {
      this.processorData.steps[5].formData.consultDate.value = date;
    }

    this.processorData.steps[5].formData.consultTime.value = time;

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }
  },
  methods: {
    setSearchResult( data ) {

      this.optionTab = "선택"
      this.processorData.steps[1].formData.detailInformation.items[0].value = this.processorData.steps[1].formData.detailInformation.items[0].subLabel = data.제조사;
      this.processorData.steps[1].formData.detailInformation.items[1].value = this.processorData.steps[1].formData.detailInformation.items[1].subLabel = data.공통차명;
      this.processorData.steps[1].formData.detailInformation.items[2].value = this.processorData.steps[1].formData.detailInformation.items[2].subLabel = data.등록연도;
      this.processorData.steps[1].formData.detailInformation.items[3].value = this.processorData.steps[1].formData.detailInformation.items[3].subLabel = data.차명;
      this.processorData.steps[1].formData.detailInformation.items[4].value = this.processorData.steps[1].formData.detailInformation.items[4].subLabel = data.세분;

      this.processorData.steps[1].formData.detailInformation.code = data.차명코드;

      this.processorData.steps[1].formData.detailInformation.value = {
        company: data.제조사,
        carname: data.공통차명,
        year: data.등록연도,
        carnamesdetail: data.차명,
        caroptions: data.세분,
        price: data[data.등록연도],
        id: data.차명코드
      }

      this.createinsureOptions(this.processorData.steps[1].formData.detailInformation.value)
    },
    checkAuto( data ) {
      this.autoName = data;
    },
    checkPath( data ) {
    },
    basicInformationCheck( data ) {
      if(data == '차량번호를 알고 있습니다.'){
        this.processorData.steps[0].formData.vinNumber.value = '-';
        this.processorData.steps[0].formData.carNumber.value = '';
      }
      else if(data == '차대번호를 알고 있습니다.'){
        this.processorData.steps[0].formData.carNumber.value = '-';
        this.processorData.steps[0].formData.vinNumber.value = '';
      }
      else{
        this.processorData.steps[0].formData.carNumber.value = '-';
        this.processorData.steps[0].formData.vinNumber.value = '-';
      }
    },
    submit( finalData ) {
      var tmp = JSON.parse(JSON.stringify(finalData["상담 예약"]));
      // 상담 예약 제거
      delete finalData["상담 예약"];

      
      //가입자 , 자필서명
      if(this.$route.query) {
        const query = this.$route.query;
        fetch('https://api64.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
            // client ip
            finalData.ip = ip

            if(query.procstep == "가입자" || query.procstep == "본인 확인") {
              let resPromise = this.$store.dispatch( "estimate/createItems", finalData).then(res => {
                try{
                  console.log('createdEstimate : ', res.data.data[0][0].estimate_id)
                  this.createdEstimateId = res.data.data[0][0].estimate_id
                }catch(err){}
                
              });
              
            }else if(query.procstep == "상담 예약") {
              tmp.step_datas.insureName = { value: finalData.title }
              tmp.step_datas.name = { value: this.processorData.steps[4].formData.name.value }
              tmp.step_datas.phone = { value: this.processorData.steps[4].formData.phone.value}
              tmp.ip = ip
              if(this.$route.query.event !== undefined) {
                tmp.event = true
              }

              var reservation_data = {
                customer_id: finalData.customer_id,
                "전화상담": tmp
              }

              if (this.reservation_inflow_referer_source !== '') {
                reservation_data.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
              }
              
              // 전화상담 예약 전송
              this.$store.dispatch( "reservation/createItems", reservation_data );
            }
        });
      }
    },
    searchPopup: function( status ) {
      /*
      var items = this.processorData.steps[1].formData.detailInformation.value;
      items.splice(status.index+1);

      this.processorData.steps[1].formData.detailInformation.items.forEach( ( o, index ) => {
        if(index > status.index){
          o.subLabel = o.default;
        }
      })

      this.processorData.steps[1].formData.detailInformation.value = items;

      */
      this.statusSearchOptions = status;

    },
    saveSign( value ) {
      //this.processorData.steps[5].formData.writeName.value = value.contract_signature_insured_write_name;
      this.processorData.steps[5].formData.writeSign.value = value.contract_signature_insured_write_signature;

      this.$forceUpdate();
    },
    popup: function( status ) {
      this.statusPopup = status;
    },
    searchValue: function( value ) {
      this.processorData.steps[1].formData.detailInformation.items[this.statusSearchOptions.index].subLabel = value;
      if(this.processorData.steps[1].formData.detailInformation.value.findIndex(o => o.label === this.processorData.steps[1].formData.detailInformation.items[this.statusSearchOptions.index].value) >= 0){

        var index = this.processorData.steps[1].formData.detailInformation.value.findIndex(o => o.label === this.processorData.steps[1].formData.detailInformation.items[this.statusSearchOptions.index].value);
        this.processorData.steps[1].formData.detailInformation.value.splice(index, 1);
        this.processorData.steps[1].formData.detailInformation.value.push( { label: this.processorData.steps[1].formData.detailInformation.items[this.statusSearchOptions.index].value, value: value } );
      }else{
        if(value != '미가입'){
          var tmp = { label: this.processorData.steps[1].formData.detailInformation.items[this.statusSearchOptions.index].value, value: value };
          this.processorData.steps[1].formData.detailInformation.value.push( tmp )
        }
      }
    },
    createinsureOptions: function (value){
      // 자기차량손해 데이터 초기화
      var ptc = [100, 90, 80, 70, 60]
      this.processorData.steps[3].formData.insureOptions[0].items[5].options = []
      //3,000만원(차량가액의 100%)
      ptc.forEach(o => {
        var et_price = parseInt(value.price * o / 100);
        var tmp_et_label = `${et_price}만원(차량가액의 ${o}%)`;
        this.processorData.steps[3].formData.insureOptions[0].items[5].options.push({ value: tmp_et_label, label: tmp_et_label})
        if(o == 100) {
          this.processorData.steps[3].formData.insureOptions[0].items[5].subLabel = tmp_et_label
          // 기본 선택값 변경
          this.processorData.steps[3].formData.insureOptions[0].value.filter(o => o.label == "자기차량손해")[0].value = tmp_et_label
        }
      })
      this.processorData.steps[3].formData.insureOptions[0].items[5].options.push({ value: '미가입', label: '미가입'})

    },
    searchComplete: function( value ) {

      // value: "제조사", label: "제조사", subLabel: "제조사 선택", default: "제조사 선택",
      this.createinsureOptions(value)

      this.processorData.steps[1].formData.detailInformation.value = value
      this.processorData.steps[1].formData.detailInformation.item = [];
      this.processorData.steps[1].formData.detailInformation.items = [];



      var ob = {
          value: '제조사',
          label: '제조사',
          subLabel: '제조사 선택',
          default: '제조사 선택'
      }

      this.processorData.steps[1].formData.detailInformation.item.push(ob);

      ob = {
        value: value.company,
        label: '제조사',
        subLabel: value.company,
        default: '제조사 선택'
      }
      this.processorData.steps[1].formData.detailInformation.items.push(ob);

      //{ value: "차명", label: "차명", subLabel: "차명 선택", default: "차명 선택",
      ob = {
        value: value.carname,
        label: '차명',
        subLabel: value.carname,
        default: '차명 선택'
      }
      this.processorData.steps[1].formData.detailInformation.items.push(ob);

      //value: "등록연도", label: "등록연도", subLabel: "등록연도 선택", default: "등록연도 선택",
      ob = {
        value: value.year,
        label: "등록연도",
        subLabel: value.year,
        default: '등록연도 선택'
      }
      this.processorData.steps[1].formData.detailInformation.items.push(ob);

      ob = {
        value: value.carnamesdetail,
        label: "세부차명",
        subLabel: value.carnamesdetail,
        default: "세부차명 선택"
      }
      this.processorData.steps[1].formData.detailInformation.items.push(ob);

      ob = {
        value: value.caroptions,
        label: "세부옵션",
        subLabel: value.caroptions,
        default: "세부옵션 선택"
      }
      this.processorData.steps[1].formData.detailInformation.items.push(ob);
    },
    checkValue: function( value ) {
      var insureOptionsObj = this.processorData.steps[3].formData.insureOptions[this.statusPopup.option];

      // 세부 분류가 있는 보장항목인지 확인 ( 예: 자동차 보험 - 자기신체사고 )
      if(!Array.isArray(value) && typeof value == "object") {
        insureOptionsObj.items[this.statusPopup.index].subLabel = `[${value.label}] ${value.value}`;
      }else{
        insureOptionsObj.items[this.statusPopup.index].subLabel = value;
      }


      var Vidx = insureOptionsObj.value.findIndex(o => o.label === insureOptionsObj.items[this.statusPopup.index].label);
      if(Vidx >= 0){

        if(value === '미가입' && !insureOptionsObj.requirement){
          // 필수 보장항목이 아니고, 미가입하는경우는 value 목록에서 제거
          insureOptionsObj.value.splice(Vidx, 1);
        }else{
          // 이외 값 변경
          // 단, 값이 Array 인경우가 있으므로 확인 ( 다중선택 가능한경우 )
          if(Array.isArray(insureOptionsObj.value[Vidx].value)) {
            var VIidx = insureOptionsObj.value[Vidx].value.indexOf(value);
            // 이미 arr 값이 있는경우 제거
            if(VIidx >= 0){
              //단, 최소 하나이상 선택하도록 해야하므로
              if(insureOptionsObj.value[Vidx].value.length > 0) insureOptionsObj.value[Vidx].value.splice(VIidx, 1);
            }else{
              // 추가
              insureOptionsObj.value[Vidx].value.push(value)
            }
            // 배열 값은 join으로 묶어서 표현
            insureOptionsObj.items[this.statusPopup.index].subLabel = insureOptionsObj.value[Vidx].value.join();
          }else{
            insureOptionsObj.value[Vidx].value = value;
          }
        }
      }else{
        // value 목록에 없는 경우
        if(value != '미가입'){
          // 미가입 아닌경우 값 추가
          var tmp = { label: insureOptionsObj.items[this.statusPopup.index].value, value: value };
          insureOptionsObj.value.push( tmp )
        }
      }
    },
    tab: function( tab ) {
      this.optionTab = '검색';
    },
    updateprocessorData: function (data){
      //this.processorData.steps[4].formData.haslogin.value = data.haslogin;
      this.processorData.steps[4].formData.phone.value = data.phone;
      this.processorData.steps[4].formData.name.value = data.name;
      this.processorData.steps[4].formData.email.value = data.email;
      this.processorData.steps[4].formData.birth.value = data.birth;
    },
    submitOtherEst() {
      var tmp = {
        customer_id: this.$store.state.customer.profile._id,
        "전화상담": {
          step_datas: {
            insureName: { value: "" },
            name: {  value: this.processorData.steps[4].formData.name.value },
            phone: { value: this.processorData.steps[4].formData.phone.value },
            consultDate: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultDate.value },
            consultTime: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultTime.value },
            consultRemark: { value: this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value ? this.processorData.steps[this.processorData.steps.length - 3].formData.consultRemark.value : "없음" }
          }
        }
      }
      var ost_data = this.processorData.steps[this.processorData.steps.length - 1];
      if(ost_data.value.length > 0) {
        ost_data.value.forEach(o => {
          tmp["전화상담"].step_datas.insureName.value = o

          if (this.reservation_inflow_referer_source !== '') {
            tmp.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }
          
          this.$store.dispatch( "reservation/createItems", tmp );
        })
      }
    }
  }
}
</script>
